import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { MapPinIcon, MailIcon, InstagramIcon, PlusIcon } from 'lucide-react';
import { useCart } from '../CartContext';
import { useContent } from '../ContentContext';
import { Reveal } from '../components/Reveal';
export function PartnerPage() {
  const {
    slug
  } = useParams();
  const {
    addToCart
  } = useCart();
  const {
    businesses
  } = useContent();
  const business = businesses.find(b => b.slug === slug);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);
  if (!business) {
    return <div className="pt-32 text-center text-gray-500" data-id="element-523" data-mp="2w8om350irh5g">Verksamheten hittades inte.</div>;
  }
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-524" data-mp="2hg4n8gkejvtt">
      {/* Premium Uber Eats style Header */}
      <div className="relative h-[40vh] w-full overflow-hidden md:h-[50vh]" data-id="element-525" data-mp="2mepjk4wj9vcz">
        <img src={business.cover} alt={business.name} className="absolute inset-0 h-full w-full object-cover" data-id="element-526" data-mp="28i2m810o536j" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" data-id="element-527" data-mp="2ckz2vm6nep7u" />
        <div className="absolute bottom-0 left-0 w-full p-6 md:p-10" data-id="element-528" data-mp="1vyfq7zihdk5n">
          <div className="mx-auto max-w-7xl" data-id="element-529" data-mp="1qx03m30nn5l5">
            <Reveal data-id="element-530" data-mp="25uisd5dc1isl">
              <h1 className="font-display text-5xl font-medium text-white md:text-6xl lg:text-7xl" data-id="element-531" data-mp="25v2b2oat4b7o">{business.name}</h1>
              <p className="mt-4 text-lg font-medium text-white/90" data-id="element-532" data-mp="20x0r815k47v5">{business.services}</p>
            </Reveal>
          </div>
        </div>
      </div>

      <div className="mx-auto mt-12 grid max-w-7xl gap-12 px-6 md:grid-cols-[1fr,320px] md:px-10" data-id="element-533" data-mp="1871urkp198gg">
        {/* Main Content - Menu */}
        <div data-id="element-534" data-mp="1mwzpkjhgwwem">
          <Reveal delay={0.1} data-id="element-535" data-mp="1mxhjvakkl0jw">
            <h2 className="font-display text-3xl font-medium text-gray-900 mb-8" data-id="element-536" data-mp="1mxrdd84tppuc">Meny</h2>
            <div className="grid gap-6 sm:grid-cols-2" data-id="element-537" data-mp="1i350f0j3fp85">
              {business.products.map(product => <div key={product.id} className="group flex h-full flex-col overflow-hidden rounded-3xl bg-white shadow-premium transition-all hover:shadow-premium-hover hover:-translate-y-1" data-id="element-538" data-mp="udanyk2os2of">
                  <div className="relative h-48 overflow-hidden" data-id="element-539" data-mp="1f2vcm8rgqbqf">
                    <img src={product.image} alt={product.name} className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-540" data-mp="1j4qd5b1kkl35" />
                    <div className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-gray-900 backdrop-blur-md" data-id="element-541" data-mp="1swmcepfe6h8y">
                      {product.category}
                    </div>
                  </div>
                  <div className="flex flex-1 flex-col p-6" data-id="element-542" data-mp="109i4abl05msy">
                    <h3 className="font-display text-xl font-medium text-gray-900" data-id="element-543" data-mp="155qoi3e2466z">{product.name}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-gray-500 line-clamp-2" data-id="element-544" data-mp="1a6eeqmugoj05">{product.description}</p>
                    
                    <div className="mt-auto pt-6 flex items-center justify-between" data-id="element-545" data-mp="2go1i8s6dngoy">
                      <span className="text-lg font-medium text-gray-900" data-id="element-546" data-mp="2lixe63eqio7c">{product.price} kr</span>
                      <button onClick={() => addToCart(product)} className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-gray-900 transition-colors hover:bg-black hover:text-white" aria-label="Lägg till" data-id="element-547" data-mp="9wn663ocr32y">
                        <PlusIcon className="h-5 w-5" data-id="element-548" data-mp="3ncb7c4bv87wm" />
                      </button>
                    </div>
                  </div>
                </div>)}
            </div>
          </Reveal>
        </div>

        {/* Sidebar */}
        <aside className="space-y-6" data-id="element-549" data-mp="3dewvyj4su9b6">
          <Reveal delay={0.2} data-id="element-550" data-mp="3dfyh5gfj4c6m">
            <div className="rounded-3xl bg-white p-8 shadow-premium" data-id="element-551" data-mp="38fk6rrqggq5f">
              <h3 className="font-display text-xl font-medium text-gray-900" data-id="element-552" data-mp="38herp61q8i9i">Om {business.name}</h3>
              <div className="mt-4 space-y-4 text-sm leading-relaxed text-gray-600" data-id="element-553" data-mp="16nnyqs3hxyfe">
                {business.description.map((p, i) => <p key={i} data-id="element-554" data-mp="1entzfgiintv5" data-mpi={i}>{p}</p>)}
              </div>
              
              <div className="mt-8 space-y-4 border-t border-gray-100 pt-6 text-sm text-gray-600" data-id="element-555" data-mp="1emiwfiwwaq53">
                <div className="flex items-start gap-3" data-id="element-556" data-mp="1jl3v3dwi11rf">
                  <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-gray-400" data-id="element-557" data-mp="14pe7jbbo0gkl" />
                  <span data-id="element-558" data-mp="19ohc6unqgks1">{business.contact.address}</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-559" data-mp="vy5i4q7l8by9">
                  <MailIcon className="h-4 w-4 shrink-0 text-gray-400" data-id="element-560" data-mp="vwkor3x0ez1z" />
                  <a href={`mailto:${business.contact.email}`} className="hover:text-black" data-id="element-561" data-mp="10pdsppknm3d0">{business.contact.email}</a>
                </div>
                <div className="flex items-center gap-3" data-id="element-562" data-mp="lxv3d15wmwgz">
                  <InstagramIcon className="h-4 w-4 shrink-0 text-gray-400" data-id="element-563" data-mp="qzkgqnglnm88" />
                  <a href="#" className="hover:text-black" data-id="element-564" data-mp="cyrjvw2tsf1y">{business.contact.instagram}</a>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.3} data-id="element-565" data-mp="h2fw4s2ejytj">
            <div className="rounded-3xl bg-white p-8 shadow-premium" data-id="element-566" data-mp="3ugx5fl8ma4cm">
              <h3 className="font-display text-xl font-medium text-gray-900" data-id="element-567" data-mp="3pilwdcq5bxvg">Perfekt för</h3>
              <ul className="mt-6 flex flex-wrap gap-2" data-id="element-568" data-mp="3pkyje4argyfd">
                {business.perfectFor.map(occasion => <li key={occasion} className="rounded-full bg-gray-100 px-4 py-2 text-xs font-medium text-gray-600" data-id="element-569" data-mp="2e5zcsugboll">
                    {occasion}
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </aside>
      </div>
    </div>;
}